import { Breadcrumb, Skeleton, Row, Col, Select } from 'antd';
import { ButtonAction, Card, Form, FormItem, GetValidateFields, Confirm, Button, AsumsiIcon, Input } from 'asumsi-components';
import { LayoutCMS } from 'components';
import React, { useEffect, useState } from 'react';
import useAction from './hooks/useAction';
import staticAction from "@pages/statics/hooks/useAction";
import { IResponseStatic } from '@interfaces/iresponse-static';

const { Option } = Select;
export const PageFooterFormComponent = (props: any) => {
    // set header page
    const title = 'Footer'
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    {title}
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };

    // declare action and attribute needed
    const { isLoader, getData, postData, data } = useAction();
    const { getData: getStatics, data: statics } = staticAction();

    // initiate form data
    const initialFieldsValues: any = {
        menuRow1: [{ staticId: "", orderNumber: 1 }],
        menuRow2: [{ staticId: "", orderNumber: 1 }],
        socialMedia: [{ url: "", type: "", orderNumber: 1 }],
        errors: ["menuRow1", "menuRow2", "socialMedia"]
    };

    const [fieldsValues, setFieldsValues]: any = useState(initialFieldsValues);
    const [showConfirmation, setShowConfirm] = useState(false);
    const [paramSubmit, setParamSubmit] = useState({});

    // first load
    useEffect(() => {
        getStatics({ all: true });
        if (!data) {
            getData();
        }
        else {
            setDefault();
        }
    }, [data])

    // fetch data
    const setDefault = async () => {
        if (data) {
            const errors: string[] = [];
            if (data.menuRow1 && data.menuRow1.length == 0) errors.push('menuRow1');
            if (data.menuRow2 && data.menuRow2.length == 0) errors.push('menuRow2');
            if (data.socialMedia && data.socialMedia.length == 0) errors.push('socialMedia');

            setFieldsValues({
                menuRow1: data.menuRow1.length > 0 ? data.menuRow1 : [{ staticId: "", orderNumber: 1 }],
                menuRow2: data.menuRow2.length > 0 ? data.menuRow2 : [{ staticId: "", orderNumber: 1 }],
                socialMedia: data.socialMedia.length > 0 ? data.socialMedia : [{ url: "", type: "", orderNumber: 1 }],
                errors
            });
        }
    }

    // handle submit form
    const handleSubmit = (e: any) => {
        const validateFields = GetValidateFields(fieldsValues);
        const { err, values } = validateFields;
        e.preventDefault();
        if (!err) {
            setParamSubmit(values);
            setShowConfirm(true);
        }
    };

    const onChangeStaticRow = (value: any, orderNumber: string, staticType: string) => {
        const newData = staticType == "menuRow1" ? fieldsValues.menuRow1 : fieldsValues.menuRow2;
        const index = newData.findIndex((element: any) => element.orderNumber == orderNumber);
        if (index >= 0) {
            newData[index] = { staticId: value, orderNumber };
        }
        const existErrors = checkErrors(newData, staticType);
        if (staticType == "menuRow1") {
            setFieldsValues({ ...fieldsValues, menuRow1: newData, errors: existErrors });
        } else {
            setFieldsValues({ ...fieldsValues, menuRow2: newData, errors: existErrors });
        }
    }


    const checkErrors = (newData: any, staticType: string) => {
        const existErrors: string[] = fieldsValues.errors;
        const indexErrors = existErrors.findIndex((element: any) => element == staticType);
        if (indexErrors >= 0) {
            existErrors.splice(indexErrors, 1);
        }
        if (staticType == "socialMedia") {
            if (newData.filter((ft: any) => ft.url == "" || ft.type == "").length > 0) existErrors.push(staticType);
        }
        else {
            if (newData.filter((ft: any) => ft.staticId == "").length > 0) existErrors.push(staticType);
        }

        return existErrors;
    }

    const addNewPageRow = (staticType: string) => {
        const newData = staticType == "menuRow1" ? fieldsValues.menuRow1 ?? [] : fieldsValues.menuRow2 ?? [];
        newData.push({ orderNumber: newData.length + 1, staticId: "" });

        const existErrors = checkErrors(newData, staticType);

        if (staticType == "menuRow1") {
            setFieldsValues({ ...fieldsValues, menuRow1: newData, errors: existErrors });
        } else {
            setFieldsValues({ ...fieldsValues, menuRow2: newData, errors: existErrors });
        }
    }

    const deletePageRow = (orderNumber: number, staticType: string) => {
        let newData = staticType == "menuRow1" ? fieldsValues.menuRow1 : fieldsValues.menuRow2;
        const index = newData.findIndex((element: any) => element.orderNumber == orderNumber);
        if (index >= 0) {
            newData.splice(index, 1);
        }
        newData = newData.map((dt: any, index: number) => Object.assign({ staticId: dt.staticId, orderNumber: index + 1 }));

        const existErrors = checkErrors(newData, staticType);

        if (staticType == "menuRow1") {
            setFieldsValues({ ...fieldsValues, menuRow1: newData, errors: existErrors });
        } else {
            setFieldsValues({ ...fieldsValues, menuRow2: newData, errors: existErrors });
        }
    }

    const onChangesocialMediaRow = (value: any, orderNumber: string, inputType: string) => {
        const newData = fieldsValues.socialMedia;
        const index = newData.findIndex((element: any) => element.orderNumber == orderNumber);
        if (index >= 0) {
            if (inputType == 'type') {
                newData[index] = { ...newData[index], type: value, orderNumber };
            } else {
                newData[index] = { ...newData[index], url: value, orderNumber };
            }

        }

        const existErrors = checkErrors(newData, "socialMedia");
        setFieldsValues({ ...fieldsValues, socialMedia: newData, errors: existErrors });
    }

    const addNewsocialMediaRow = () => {
        const newData = fieldsValues.socialMedia ?? [];
        newData.push({ orderNumber: newData.length + 1, type: "", url: "" });

        const existErrors = checkErrors(newData, "socialMedia");

        setFieldsValues({ ...fieldsValues, socialMedia: newData, errors: existErrors });
    }

    const deletesocialMediaRow = (orderNumber: number) => {
        let newData = fieldsValues.socialMedia;
        const index = newData.findIndex((element: any) => element.orderNumber == orderNumber);
        if (index >= 0) {
            newData.splice(index, 1);
        }
        newData = newData.map((dt: any, index: number) => Object.assign({ url: dt.url, type: dt.type, orderNumber: index + 1 }));

        const existErrors = checkErrors(newData, "socialMedia");

        setFieldsValues({ ...fieldsValues, socialMedia: newData, errors: existErrors });
    }

    const optionStatics = statics ? statics.map((stat: IResponseStatic) => <Option key={stat.id} value={stat.id}>{stat.title}</Option>) : null;

    // return JSX Element 
    return (
        <LayoutCMS {...layoutCMSProps}>
            <Card className="asumsi-card-form-shadow-rd-15">
                <Form>
                    <Skeleton loading={isLoader}>
                        <Row gutter={30}>
                            <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                                <Card className="m-b-20">
                                    <div className="title-desc">
                                        <div className="title">MENU ROW 1</div>
                                        <div className="info"> max 5 menu in row</div>
                                    </div>
                                    {fieldsValues.menuRow1 && fieldsValues.menuRow1.length > 0 && fieldsValues.menuRow1.map((rowData: any, index: number) => <Row>
                                        <Col span={24} style={{ display: "flex" }}>
                                            <FormItem className="action-tools" width="3%">
                                                <Button type="default" className={`${index == 0 && "hidden"}`}
                                                    onClick={() => deletePageRow(rowData.orderNumber, "menuRow1")}
                                                >
                                                    <AsumsiIcon icon="trash" />
                                                </Button>
                                            </FormItem>
                                            <FormItem width="90%" className={`${!rowData.staticId && "asumsi-form-error"}`} hideRequiredMark={true} labelAlign="left"
                                                fieldDecorator={{
                                                    label: "page",
                                                    rules: [{
                                                        message: 'Please input page',
                                                        required: true,
                                                    }
                                                    ]
                                                }}
                                            >
                                                <div>
                                                    <Select style={{ width: "100%" }} id="page" defaultValue={rowData.staticId} value={rowData.staticId} onChange={(value: string) => onChangeStaticRow(value, rowData.orderNumber, "menuRow1")}>
                                                        {optionStatics}
                                                    </Select>
                                                    {!rowData.staticId && <label style={{ color: "red" }}>Please select page</label>}
                                                </div>
                                            </FormItem>
                                        </Col>
                                    </Row>)}
                                    <Row style={{ display: `${fieldsValues.menuRow1.length < 5 ? 'block' : 'none'}` }}>
                                        <Button iconLeft="plus" text="Add Page" type="primary" size="medium" onClick={() => addNewPageRow("menuRow1")} disabled={fieldsValues.menuRow1.filter((dt: any) => dt.staticId == "").length > 0}></Button>
                                    </Row>
                                </Card>
                                <Card>
                                    <div className="title-desc">
                                        <div className="title">MENU ROW 2</div>
                                        <div className="info"> max 5 menu in row</div>
                                    </div>
                                    {fieldsValues.menuRow2 && fieldsValues.menuRow2.length > 0 && fieldsValues.menuRow2.map((rowData: any, index: number) => <Row>
                                        <Col span={24} style={{ display: "flex" }}>
                                            <FormItem className="action-tools" width="3%">
                                                <Button type="default" className={`${index == 0 && "hidden"}`}
                                                    onClick={() => deletePageRow(rowData.orderNumber, "menuRow2")}
                                                >
                                                    <AsumsiIcon icon="trash" />
                                                </Button>
                                            </FormItem>
                                            <FormItem width="90%" className={`${!rowData.staticId && "asumsi-form-error"}`} hideRequiredMark={true} labelAlign="left"
                                                fieldDecorator={{
                                                    label: "page",
                                                    rules: [{
                                                        message: 'Please input page',
                                                        required: true,
                                                    }
                                                    ]
                                                }}
                                            >
                                                <div>
                                                    <Select style={{ width: "100%" }} id="page" defaultValue={rowData.staticId} value={rowData.staticId} onChange={(value: string) => onChangeStaticRow(value, rowData.orderNumber, "menuRow2")}>
                                                        {optionStatics}
                                                    </Select>
                                                    {!rowData.staticId && <label style={{ color: "red" }}>Please select page</label>}
                                                </div>
                                            </FormItem>
                                        </Col>
                                    </Row>)}
                                    <Row style={{ display: `${fieldsValues.menuRow2.length < 5 ? 'block' : 'none'}` }}>
                                        <Button iconLeft="plus" text="Add Page" type="primary" size="medium" onClick={() => addNewPageRow("menuRow2")} disabled={fieldsValues.menuRow2.filter((dt: any) => dt.staticId == "").length > 0}></Button>
                                    </Row>
                                </Card>
                                <Card>
                                    <div className="title-desc">
                                        <div className="title">SOCIAL MEDIA</div>
                                    </div>
                                    {fieldsValues.socialMedia && fieldsValues.socialMedia.length > 0 && fieldsValues.socialMedia.map((rowData: any, index: number) => <Row>
                                        <Col span={24} style={{ display: "flex" }}>
                                            <FormItem className="action-tools" width="3%">
                                                <Button type="default" className={`${index == 0 && "hidden"}`}
                                                    onClick={() => deletesocialMediaRow(rowData.orderNumber)}
                                                >
                                                    <AsumsiIcon icon="trash" />
                                                </Button>
                                            </FormItem>
                                            <FormItem width="20%" className={`${!rowData.type && "asumsi-form-error"}`} hideRequiredMark={true} labelAlign="left"
                                                fieldDecorator={{
                                                    label: "page",
                                                }}
                                            >
                                                <div>
                                                    <Select style={{ width: "90%" }} id="page" defaultValue={rowData.type} value={rowData.type} onChange={(value: string) => onChangesocialMediaRow(value, rowData.orderNumber, "type")}>
                                                        <Option key="instagram" value="instagram">instagram</Option>
                                                        <Option key="twitter" value="twitter">twitter</Option>
                                                        <Option key="facebook" value="facebook">facebook</Option>
                                                    </Select>
                                                    {!rowData.type && <label style={{ color: "red" }}>Please select social media type</label>}
                                                </div>
                                            </FormItem>
                                            <FormItem width="90%" className={`${!rowData.url && "asumsi-form-error"}`} hideRequiredMark={true} labelAlign="left"
                                                fieldDecorator={{
                                                    label: "url",
                                                    rules: [{
                                                        message: 'Please input url',
                                                        required: true,
                                                    }
                                                    ]
                                                }}
                                            >
                                                <div>
                                                    <Input id="url" defaultValue={rowData.url} value={rowData.url} onChange={(e: any) => onChangesocialMediaRow(e.target.value, rowData.orderNumber, "url")} />
                                                    {!rowData.url && <label style={{ color: "red" }}>Please input url</label>}
                                                </div>
                                            </FormItem>
                                        </Col>
                                    </Row>)}
                                    <Row>
                                        <Button iconLeft="plus" text="Add Social Media" type="primary" size="medium" onClick={addNewsocialMediaRow} disabled={fieldsValues.socialMedia.filter((dt: any) => dt.url == "").length > 0}></Button>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Skeleton>
                    <ButtonAction
                        right={
                            <Button type="green" size="medium" disabled={fieldsValues.errors && fieldsValues.errors.length > 0} loading={isLoader} onClick={handleSubmit}>
                                Save
                            </Button>
                        }
                    />
                </Form>
            </Card>
            <Confirm
                key="confirm-save"
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    // do post data
                    postData(paramSubmit);
                }}
                content='Apakah Anda yakin untuk menyimpan data ini?'
                title='Konfirmasi'
                okText='Ya'
                cancelText='Tidak'
            />
        </LayoutCMS>
    );
};
export default PageFooterFormComponent;



// WEBPACK FOOTER //
// ./src/pages/footer-form/component.tsx